module.exports = __webpack_public_path__ + "img/user-login.a5cb3520.svg";